import { FormControl } from '@chakra-ui/react';
import { useClassFiltersStore } from '@stores/classes';
import { useListCoaches } from 'hooks/useApiQueries';
import { useCoachStudioParams } from 'hooks/useCoachStudioParams';
import { useLayoutEffect } from 'react';
import Select from 'react-select';

export function ClassesFiltersCoaches() {
  const { data: coaches, isLoading } = useListCoaches();
  const coachId = useClassFiltersStore((state) => state.coachId);
  const setCoachId = useClassFiltersStore((state) => state.setCoachId);

  const { isCoachUrl, id } = useCoachStudioParams();
  useLayoutEffect(() => {
    if (isCoachUrl) setCoachId(id);
  }, [isCoachUrl, id, setCoachId]);

  const options =
    coaches
      ?.filter((coach) => {
        if (!mondayMindbody?.siteId) return true;
        return mondayMindbody.siteId === String(coach.SiteId);
      })
      .sort((previous, next) => previous.FirstName.localeCompare(next.FirstName))
      .map((coach) => ({ label: coach.FirstName, value: coach.Id })) ?? [];

  const value = options.find((option) => option.value === coachId);
  return (
    <FormControl>
      <Select
        isLoading={isLoading}
        onChange={(option) => setCoachId(option?.value ?? null)}
        value={value}
        placeholder="Filtrer par coach"
        className="coachesSelect"
        options={options}
        isClearable
      />
    </FormControl>
  );
}
